__turbopack_context__.v({
  "button": "fixed-cta-button-module-scss-module__VHmS8G__button",
  "wrap": "fixed-cta-button-module-scss-module__VHmS8G__wrap",
  "wrapHidden": "fixed-cta-button-module-scss-module__VHmS8G__wrapHidden",
});
